import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import "./media.css";

export default class Media extends Component {
  constructor(props) {
    super(props);
  }

  onMediaClick = () => {
    const { actions, media, selectedMediaItem } = this.props;

    if (selectedMediaItem.get(media.get("uid"))) {
      actions.unselectMediaItem(media.get("uid"));
    } else {
      actions.selectMediaItem(media.get("uid"));
    }
  };

  render() {
    const { apiHost, media, selectedMediaItem } = this.props;

    return (
      <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
        <div
          onClick={this.onMediaClick}
          className={
            selectedMediaItem.get(media.get("uid")) ? (
              "media-item-modal selected"
            ) : (
              "media-item-modal"
            )
          }
        >
          <img src={`${apiHost}/v1/files/${media.get("fileUID")}/file`} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/media.react.js